var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"app"}},[_c('Navbar'),(this.$store.getters.alert.display)?_c('Alert',{attrs:{"text":this.$store.getters.alert.text,"type":this.$store.getters.alert.type}}):_vm._e(),_c('router-view'),_c('Footer')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }